import styled from 'styled-components';

export const InputContainer = styled.div`
  margin-bottom: 10px;
`;

export const SaveButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  position: absolute;
  bottom: 30px;
  right: 5px;
  margin-right: 40px;
  gap: 20px;
`;
